/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionSourceQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("DimensionSourceQueryOperator");
    }

    getFixupPrototypeFunction() { return DimensionSourceQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<DimensionSourceQueryOperator>): DimensionSourceQueryOperator {
        let obj = Object.assign(new DimensionSourceQueryOperator(), model);
        DimensionSourceQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionSourceQueryOperator>): DimensionSourceQueryOperator {
        if (!model) return null;
        return DimensionSourceQueryOperator.newInstance(<DimensionSourceQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionSourceQueryOperator) {
        if (!obj) return;

        models.DimensionSourceQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionSourceQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DimensionSourceQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Sources for Dimension Definition
     */
    dimension_sources: Array<models.DimensionSource>;

}
